/**
 * Configuración Socket.io - landing-base-client
 * Usa la misma URL base que la API
 */
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5040';

export const getSocketUrl = () => {
  try {
    const url = new URL(API_BASE);
    return url.origin;
  } catch {
    return 'http://localhost:5040';
  }
};

export default getSocketUrl;
